import React from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import SportEntriesTeamsTable from "components/common/entries/SportEntriesTeamsTable";
import { ALL_URL } from "helpers/utils";

const SportEntriesTeam = ({data}) => {
    const [dataState, setDataState] = React.useState([]);
    const [message, setMessage] = React.useState('');
    const {mirs_discipline, mirs_event} = useUrlFriendlyToParameters()

    React.useEffect(() => {

        // let teams = data?.teams
        let teams = data
        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            teams = teams?.filter(item => item?.discipline?.code === mirs_discipline);
        }

        if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
            teams = teams?.filter(item => item?.registeredEvents?.some(e => e?.code === mirs_event))
        }

        //in entries we will display Organization longDescription but only when TeamType=ORG any other Teamtype will use "name"
        teams = teams?.filter(team => team?.organisation !== undefined).map(team => {
            if (team?.teamType !== "ORG") {
                // Update the longDescription in the organisation object with the name value
                team.organisation.longDescription = team?.name;
            }
            return team;
        });

        // Sort the array based on the updated longDescription
        teams = teams?.sort((a, b) => {
            return a?.organisation?.longDescription?.toLowerCase().localeCompare(b?.organisation?.longDescription?.toLowerCase());
        });

        setMessage('');
        setDataState(teams);
    }, [data, mirs_discipline, mirs_event]);


    return (<>
        {dataState && <SportEntriesTeamsTable data={dataState} key={`teams`} />}
    </>
    )
};
export default SportEntriesTeam

